export default () => ({
  isModalLaunched: false,
  modalComponent: undefined,
  modalProperties: {},
  modalCloseCallback: undefined,
})
